export const BoxIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="28"
      height="31"
      viewBox="0 0 28 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.4826 27.3915V16.0313L2.55487 10.2945V21.6544L12.4826 27.3915ZM14.9749 27.3915L24.8936 21.6544V10.257L14.9749 16.0253V27.3915ZM13.7242 13.9091L23.502 8.21325L13.7242 2.55488L3.918 8.21325L13.7242 13.9091ZM1.27762 23.877C0.867375 23.6365 0.551875 23.3194 0.331125 22.9256C0.110375 22.5319 0 22.1093 0 21.6578V8.99775C0 8.54625 0.110375 8.12363 0.331125 7.72988C0.551875 7.33613 0.867375 7.019 1.27762 6.7785L12.4466 0.335999C12.8529 0.111999 13.2807 0 13.7302 0C14.18 0 14.6039 0.111999 15.0019 0.335999L26.1709 6.7785C26.5811 7.019 26.8981 7.33613 27.1219 7.72988C27.3456 8.12363 27.4575 8.54625 27.4575 8.99775V21.6578C27.4575 22.1093 27.3456 22.5319 27.1219 22.9256C26.8981 23.3194 26.5811 23.6365 26.1709 23.877L15.0019 30.3105C14.5956 30.5405 14.1677 30.6555 13.7182 30.6555C13.2685 30.6555 12.8446 30.5405 12.4466 30.3105L1.27762 23.877Z"
        fill="currentColor"
      />
    </svg>
  );
};
